import React from 'react';
import CustomSingleSelect from '../../../../util_components/custom_single_select';
import { cellHalf } from './formatters';
import './prices_table.css';

const TERMS = [
  { key: 'm1', label: '1 month' },
  { key: 'm3', label: '3 months' },
  { key: 'm6', label: '6 months' },
  { key: 'm13', label: '13 months' },
];

function Half({ symbol, total, perMonth }) {
  const parts = cellHalf(symbol, total, perMonth);
  return (
    <td className="pt-cell">
      <div className="pt-total">{parts.total}</div>
      {parts.perMonth ? <div className="pt-permonth">{parts.perMonth}</div> : null}
    </td>
  );
}

function Cell({ symbol, cell }) {
  if (!cell) {
    return (
      <>
        <td className="pt-cell">—</td>
        <td className="pt-cell">—</td>
      </>
    );
  }
  return (
    <>
      <Half symbol={symbol} total={cell.lto_total} perMonth={cell.lto_per_month} />
      <Half symbol={symbol} total={cell.post_total} perMonth={cell.post_per_month} />
    </>
  );
}

export default function PricesTable(props) {
  const { data, loading, error, currency, currencyOptions, onCurrencyChange } = props;
  const symbol = data?.currency_symbol || '';

  return (
    <div className="pt-wrap">
      <div className="pt-toolbar">
        <CustomSingleSelect
          label="Currency"
          name="prices_table_currency"
          value={currency}
          onChange={onCurrencyChange}
          options={currencyOptions || []}
          defaultOption="Select currency"
        />
      </div>

      <div className="pt-legend">
        These are the logged-in offer prices shown to users. <b>LTO</b> = limited-time first-cycle
        offer; <b>Post-LTO</b> = standard recurring price. Consistency plans never include an LTO.
        Per-month figures are per 4-week cycle.
      </div>

      {loading ? <div className="pt-status">Loading prices…</div> : null}
      {error ? <div className="pt-status pt-error">{error}</div> : null}

      {!loading && !error && data && (!Array.isArray(data.rows) || data.rows.length === 0) ? (
        <div className="pt-status">No prices available for this currency.</div>
      ) : null}

      {!loading && !error && data && Array.isArray(data.rows) && data.rows.length > 0 ? (
        <div className="pt-scroll">
          <table className="pt-table">
            <thead>
              <tr>
                <th className="pt-plan-col" rowSpan={2} scope="col">Plan</th>
                {TERMS.map((t) => (
                  <th key={t.key} colSpan={2} className="pt-term-head" scope="colgroup">{t.label}</th>
                ))}
              </tr>
              <tr>
                {TERMS.map((t) => (
                  <React.Fragment key={t.key}>
                    <th className="pt-sub-head" scope="col" aria-label={`${t.label} limited-time offer`}>LTO</th>
                    <th className="pt-sub-head" scope="col" aria-label={`${t.label} regular price`}>Post-LTO</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((row) => (
                <tr key={`${row.plan_type}-${row.sessions_per_week}`}>
                  <td className="pt-plan-col pt-plan-label" scope="row">{row.plan_label}</td>
                  {TERMS.map((t) => (
                    <Cell key={t.key} symbol={symbol} cell={row.cells?.[t.key]} />
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
